// extracted by mini-css-extract-plugin
export default {"administrador_sitio_page_container":"AdministradorSitio_administrador_sitio_page_container__z+6R0"};